import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { BlogPostView } from '../components/blog/BlogPostView';
import { apiGet } from '../api/apiClient';
import './Blog.scss';

export function Blog() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setNotFound(false);
    setError(null);
    apiGet(`/blog-get.php?slug=${encodeURIComponent(slug)}`)
      .then((data) => {
        setPost(data);
        setLoading(false);
      })
      .catch((err) => {
        if (err.status === 404) {
          setNotFound(true);
        } else {
          setError('Nie udało się załadować wpisu.');
        }
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div className="blog-article blog-article--state">
        <p className="blog-status">Ładowanie&hellip;</p>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="blog-article blog-article--state">
        <p className="blog-status">Nie znaleziono wpisu.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-article blog-article--state">
        <p className="blog-status blog-status--error">{error}</p>
      </div>
    );
  }

  return (
    <div className="blog-article">
      <BlogPostView post={post} />
    </div>
  );
}
